<template>
  <b-overlay :show="loading">
    <div class="row scroll">
      <div class="col-12" style="margin: 0 auto;">
        <div class="row">
          <div class="col-6">
            <vs-list>
              <vs-list-item
                icon="info"
                v-if="auctionsStates[auction.estado]"
                :title="auctionsStates[auction.estado].label"
                subtitle="Estado Subasta"
              />
            </vs-list>
            <vs-list>
              <vs-list-item
                icon="event"
                v-if="auction.estado === auctionsStateCode.publicada"
                :title="auction.fechaPublicacion | dateFormat"
                subtitle="Fecha de Publicación"
              />
            </vs-list>
          </div>
          <div class="col-6">
            <vs-list>
              <vs-list-item
                icon="event"
                :title="auction.fechaCreacion | dateFormat"
                subtitle="Fecha de Creación"
              />
            </vs-list>
          </div>
          <div class="col-12">
            <b-form data-vv-scope="auction-form">
              <b-form-group
                label="Fecha subasta"
                class="mb-3"
              >
                <date-picker
                  name="date"
                  v-model="auctionPlanner.fechaSubasta"
                  class="w-100"
                  format="DD MMM YYYY"
                  value-type="YYYY-MM-DD"
                  type="date"
                  data-vv-as="fecha de subasta"
                  placeholder="Fecha de subasta"
                  v-validate="'required'"
                  data-cy="auction-date-planner"
                  :disabled="onlyReadInfo"
                />
                <div v-if="errors.has('auction-form.date')">
                  <small class="text-danger">
                    {{ errors.first('auction-form.date') }}
                  </small>
                </div>
              </b-form-group>
              <b-form-group
                label="Aduana coordinadora"
                class="mb-3"
              >
                <v-select
                  :disabled="onlyReadInfo"
                  v-model="auctionPlanner.gestoraId"
                  :options="customsCompanies"
                  :reduce="company => company.id"
                  name="managingCustoms"
                  :state="errors.has('auction-form.managingCustoms') ? false : null"
                  v-validate="'required'"
                  data-vv-as="aduana coordinadora"
                  :danger="errors.has('auction-form.managingCustoms')"
                  :danger-text="errors.first('auction-form.managingCustoms')"
                >
                  <span slot="no-options">
                    No hay coincidencias
                  </span>
                </v-select>
                <div
                  v-if="errors.first('auction-form.managingCustoms')"
                  class="con-text-validation span-text-validation-danger
                 vs-input--text-validation-span v-enter-to"
                  style="height: 32px;"
                >
                  <span class="span-text-validation">
                    El campo aduana coordinadora es obligatorio
                  </span>
                </div>
              </b-form-group>
            </b-form>
            <div class="text-right" v-if="!onlyReadInfo">
              <b-button
                data-cy="save"
                class="badge-glow ml-3 mb-5"
                variant="primary"
                size="sm"
                @click="attemptUpdateAuction()"
              >
                Guardar cambios
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mt-5">
        <h5 class="text-primary">
          Lotes de la Subasta
        </h5>
        <div v-if="!selectedAuctionBatches.documentos.length">
          <span class="lead collapse-title">
            Subasta no cuenta con lotes asociados
          </span>
        </div>
        <b-button
          size="sm"
          v-if="selectedBatches.length > 1"
          variant="outline-danger"
          data-cy="cancel-batch"
          v-has-permission="'ED195'"
          v-on:click="showAlertDeleteActionBatch"
        >
          <feather-icon icon="TrashIcon" />
          Quitar lotes seleccionados de subasta
        </b-button>
        <div v-if="selectedAuctionBatches.documentos.length">
          <div class="row bg-white shadow py-5 px-3 mb-4">
            <div class="col-11">
              <div class="row">
                <div class="col-2 text-center">
                  <b>#</b>
                </div>
                <div class="col-5">
                  <b>Descripción</b>
                </div>
                <div class="col-5">
                  <b>Información</b>
                </div>
              </div>
            </div>
            <div class="col-1 text-center">
              <b>...</b>
            </div>
          </div>
          <AuctionDetailRow
            v-for="batch in selectedAuctionBatches.documentos"
            :key="batch.loteId"
            :batch="batch"
            :only-read="onlyReadInfo"
            data-cy="auction-detail-row"
            v-on:select-check-batch="selectCheckBatch"
            v-on:unselect-check-batch="unSelectCheckBatch"
            v-on:handle-delete-auction-batch="deleteAuctionBatch"
          />
        </div>
        <div class="text-right">
          <b-button
            class="badge-glow ml-3 mt-5"
            variant="secondary"
            data-cy="edit-auction-status"
            size="sm"
            v-has-permission="'ED178'"
            v-if="canAddBatch"
            v-on:click="openBatchForm()"
          >
            <feather-icon
              icon="list"
              class="mr-50"
            />
            <span class="align-middle">Agregar lotes</span>
          </b-button>
          <b-button
            class="badge-glow ml-3 mt-5"
            variant="primary"
            data-cy="edit-auction-status"
            size="sm"
            v-has-permission="'ED196'"
            v-if="canPlanifyAuction"
            v-on:click="updateAuction(auctionsActionStates.PLANIFICAR)"
          >
            <feather-icon
              icon="list"
              class="mr-50"
            />
            <span class="align-middle">Comenzar a planificar</span>
          </b-button>
          <b-button
            class="badge-glow ml-3 mt-5"
            variant="primary"
            data-cy="auction-replan-button"
            size="sm"
            @click="auctionReplan(auction)"
            v-if="auction.estado === auctionsStateCode.planificada && !onlyReadInfo"
          >
            Re-Planificar
          </b-button>
        </div>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

import { ALERT_POSITION } from '@/febos/global/utils/configurations';
import { auctionsStates, auctionsStateCode, auctionsActionStates } from '@/febos/aduanas/auctions/views/utils/constants';
import AuctionDetailRow from '@/febos/aduanas/auctions/views/components/AuctionDetailRow';
import { ioGetHoldingCompanies } from '@/febos/servicios/api/v2.companies.api';
import { updateAuction } from '@/febos/servicios/api/aduanas/auctions.api';
import { batchesCodeSates } from '@/febos/aduanas/batches/views/utils/constants';

export default {
  name: 'AuctionDetail',
  components: {
    AuctionDetailRow,
    DatePicker
  },
  data() {
    return {
      auctionsStates,
      auctionsStateCode,
      auctionsActionStates,
      selectedBatches: [],
      customsCompanies: [],
      auctionPlanner: {},
      loadingCompanies: false,
      batchesCodeSates
    };
  },
  props: {
    auction: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('auctions', [
      'selectedAuctionBatches',
      'loading'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    onlyReadInfo() {
      return this.action === 'visualize';
    },
    canAddBatch() {
      return (this.auction.estado === this.auctionsStateCode.preparacion
        && !this.onlyReadInfo);
    },
    canPlanifyAuction() {
      return (this.auction.estado === this.auctionsStateCode.preparacion
        && !this.onlyReadInfo
        && this.selectedAuctionBatches.documentos.length);
    }
  },
  methods: {
    ...mapActions('auctions', [
      'deleteAuctionBatches'
    ]),
    showAlertDeleteActionBatch() {
      const lotes = this.selectedBatches.map((batch) => batch.loteId);
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: `¿Estás seguro que deseas eliminar ${this.selectedBatches.length} lote(s) seleccionado(s) de la subasta?`,
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.saveDeleteAuctionBatch(lotes)
      });
    },
    deleteAuctionBatch(batch) {
      this.selectedBatches = [];
      this.selectedBatches.push(batch);
      this.showAlertDeleteActionBatch();
    },
    saveDeleteAuctionBatch(lotes) {
      const body = {
        subastaId: this.auction.subastaId,
        lotesIdRemove: lotes
      };
      this.deleteAuctionBatches(body);
      this.selectedBatches = [];
    },
    selectCheckBatch(batch) {
      this.selectedBatches.push(batch);
    },
    unSelectCheckBatch(batch) {
      this.selectedBatches = this.selectedBatches.filter((elm) => (elm.loteId !== batch.loteId));
    },
    async updateAuction() {
      if (this.selectedAuctionBatches.documentos.some((batch) => batch.montoMinimo === 0)) {
        this.$vs.notify({
          title: 'Error',
          text: 'Hay lotes sin monto mínimo',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: ALERT_POSITION
        });
        return;
      }
      console.log(this.selectedAuctionBatches);
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: `¿Estás seguro que deseas comenzar a Planificar la subasta  N° ${this.auction.folio}?`,
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.$emit('update-auction-status', this.auctionsActionStates.PLANIFICAR)
      });
    },
    async attemptUpdateAuction() {
      const result = await this.$validator.validateAll('auction-form');
      if (!result) {
        return;
      }
      this.loadingCompanies = true;
      const auction = {
        subastaId: this.auctionPlanner.subastaId,
        gestoraId: this.auctionPlanner.gestoraId,
        fechaSubasta: this.auctionPlanner.fechaSubasta
      };
      await updateAuction(auction);
      await this.$emit('reload');
      this.loadingCompanies = false;
      this.$vs.notify({
        title: 'Genial!',
        text: 'Se han guardado los cambios correctamente',
        color: 'success',
        time: 5000,
        position: 'top-center'
      });
    },
    openBatchForm() {
      this.$router.push({
        name: 'batchs',
        params: { auctionId: this.auction.subastaId },
        query: { filters: `estado:${this.batchesCodeSates.disponible}` }
      });
    },
    auctionReplan() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: `¿Estás seguro que deseas Re-Planificar la subasta  N° ${this.auction.folio}?`,
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.$emit('update-auction-status-show-modal', this.auctionsActionStates.PREPARAR)
      });
    }
  },
  async created() {
    this.disableAddAuctionButton = false;
    this.loadingCompanies = true;
    this.customsCompanies = [];
    const response = await ioGetHoldingCompanies(
      {
        empresaId: this.company.id,
        params: {
          filtros: 'esGestoria:Y'
        }
      }
    );
    this.customsCompanies = response.data.empresas
      .map((company) => ({ id: company.empresaId, label: company.razonSocial }));
    this.loadingCompanies = false;
    this.auctionPlanner = { ...this.auction };
  }
};
</script>

<style>
.mx-input {
  padding: 20px 10px 20px 35px;
  color: #6e6b7b;
}
.mx-icon-calendar {
  left: 10px
}
</style>
